import { ApiService } from '../_services/ApiService';

interface IUpdateUserInformation {
    first_name?: string;
    last_name?: string;
    email_notification_digest_type_id?: number;
    file?: any;
}

export interface IUserFact {
    title: string;
    value: string;
    user_fact_type_id: string;
}

export interface IUserFromServer {
    first_name: string;
    last_name: string;
    profile_image_url?: any;
    id: number;
    email: string;
    email_notification_digest_type_id: number;
    created_at: string;
    last_login_at: string;
    facts?: Array<IUserFact>;
}

export class UserService extends ApiService {
    protected basePath = 'users';
    protected subPaths = {};

    public updateUser(data: IUpdateUserInformation): Promise<void> {
        return this.postRequest(data).then(response => {
            return response;
        });
    }

    public getVisibleUsers(): Promise<Array<IUserFromServer>> {
        return this.getRequest().then(response => {
            return response;
        });
    }
}



// WEBPACK FOOTER //
// ./src/Services/UserService.ts